<template>
	<div class="form-car-valuation-existing-customer-modal form" :class="{ 'nitea-modal-inner': isModalMode }">
		<div class="form-car-valuation-existing-customer-repost-card form-inner">
			<div v-if="isModalMode" class="form-header-container flex-row flex-align-center flex-justify-between">
				<button type="button" class="nitea-modal-close nitea-button is-primary is-outlined is-width-auto is-size-small has-icon-only" @click="closeModal()" aria-label="Stäng">
					<span class="icon-close icon--small"></span>
				</button>
				<div v-if="formTitle || formDescription" class="form-header">
					<template v-if="formTitle || (formDescription && mailSentStatus == null)">
						<h2 v-if="formTitle" class="form-title has-medium-font-size">{{ formTitle }}</h2>
						<p v-if="formDescription" class="form-description">{{ formDescription }}</p>
					</template>
				</div>
			</div>

			<div v-if="mailSentStatus == 'error' || mailSentStatus == 'sent'" class="form-submit-message column gap-large align-center">
				<div v-if="mailSentStatus == 'sent'" class="form-submit-success">
					<h2 class="has-large-font-size font-weight-bold">Tack för ditt meddelande</h2>
					<p class="has-body-font-size font-weight-medium">Vi återkommer inom kort på mail eller telefon.</p>
				</div>
				<div v-else-if="mailSentStatus == 'error'" class="form-submit-error">
					<h2 class="has-large-font-size font-weight-bold">Ett fel uppstod!</h2>
					<p class="has-body-font-size font-weight-medium">Ditt meddelande kunde tyvärr inte skickas. Försök igen om en liten stund.</p>
				</div>
				<button type="button" class="wp-block-nitea-gutenberg-button nitea-button is-filled is-primary is-size-small is-content-center is-width-medium" @click="closeFormMessage()">
					Stäng fönstret
				</button>
			</div>

			<form v-if="mailSentStatus === null || mailSentStatus === 'sending'" class="form-container">
				<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">1. Kontaktuppgifter *</h2>
					<div class="form-grid">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.firstName.$dirty && $v.fields.firstName.$error,
								'has-success': $v.fields.firstName.$dirty && !$v.fields.firstName.$error && fields.firstName && fields.firstName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-firstname'" placeholder=" " v-model="fields.firstName" @blur="$v.fields.firstName.$touch()" required="required" />
							<label :for="blockId + '-firstname'" class="floating-label">Förnamn</label>
							<div v-if="$v.fields.firstName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt förnamn</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.lastName.$dirty && $v.fields.lastName.$error,
								'has-success': $v.fields.lastName.$dirty && !$v.fields.lastName.$error && fields.lastName && fields.lastName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-lastname'" placeholder=" " v-model="fields.lastName" @blur="$v.fields.lastName.$touch()" required="required" />
							<label :for="blockId + '-lastname'" class="floating-label">Efternamn</label>
							<div v-if="$v.fields.lastName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt efternamn</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.email.$dirty && $v.fields.email.$error,
								'has-success': $v.fields.email.$dirty && !$v.fields.email.$error && fields.email && fields.email.length > 0,
							}"
						>
							<input type="email" :id="blockId + '-email'" placeholder=" " v-model="fields.email" @blur="$v.fields.email.$touch()" required="required" />
							<label :for="blockId + '-email'" class="floating-label">E-postadress</label>
							<div v-if="$v.fields.email.$error" class="validation-messages">
								<div class="validation-message error" v-if="!$v.fields.email.required">Vänligen ange din e-postadress</div>
								<div class="validation-message error" v-else-if="!$v.fields.email.email">Vänligen ange giltig e-postadress</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.phone.$dirty && $v.fields.phone.$error,
								'has-success': $v.fields.phone.$dirty && !$v.fields.phone.$error && fields.phone && fields.phone.length > 0,
							}"
						>
							<input type="tel" pattern="^(\+46|0)\s?\d{1,3}[\s\-]?\d{2,3}[\s\-]?\d{2}[\s\-]?\d{2}$" :id="blockId + '-phone'" placeholder=" " v-model="fields.phone" @blur="$v.fields.phone.$touch()" required="required" />
							<label :for="blockId + '-phone'" class="floating-label">Mobilnummer</label>
							<div v-if="$v.fields.phone.$dirty && $v.fields.phone.$error" class="validation-messages">
								<div class="validation-message error" v-if="!$v.fields.phone.required">Ange ditt mobilnummer</div>
								<div class="validation-message error" v-else-if="!$v.fields.phone.phonePattern">Ange ett giltigt telefonnummer (t.ex. 070-123 45 67 eller +46 70 123 45 67)</div>
							</div>
						</div>
					</div>
				</div>

				<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">2. Biluppgifter *</h2>
					<div class="form-grid">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.regnummer.$dirty && $v.fields.regnummer.$error,
								'has-success': $v.fields.regnummer.$dirty && !$v.fields.regnummer.$error && fields.regnummer && fields.regnummer.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-regnummer'" placeholder=" " v-model="fields.regnummer" @blur="$v.fields.regnummer.$touch()" required="required" minlength="6" style="text-transform: uppercase;" />
							<label :for="blockId + '-regnummer'" class="floating-label">Registreringsnummer</label>
							<div v-if="$v.fields.regnummer.$error || registrationNumber.error" class="validation-messages">
								<div class="validation-message error" v-if="!$v.fields.regnummer.required">Vänligen ange registreringsnummer</div>
								<div class="validation-message error" v-if="!$v.fields.regnummer.minLength">Registreringsnummer måste vara minst 6 tecken</div>
								<div class="validation-message error" v-if="registrationNumber.error">{{ registrationNumber.error }}</div>
							</div>
							<div class="field-result car-info" v-if="car || registrationNumber.isLoading">
								<p v-if="car">{{ car.brand }} {{ car.model }} - {{ car.model_year }}</p>
								<p v-if="registrationNumber.isLoading">Hämtar bilinformation...</p>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.mileage.$dirty && $v.fields.mileage.$error,
								'has-success': $v.fields.mileage.$dirty && !$v.fields.mileage.$error && fields.mileage && fields.mileage.length > 0,
							}"
						>
							<input type="number" :id="blockId + '-mileage'" placeholder=" " v-model="fields.mileage" min="0" @blur="$v.fields.mileage.$touch()" required="required" />
							<label :for="blockId + '-mileage'" class="floating-label">Miltal (mil)</label>
							<div v-if="$v.fields.mileage.$error" class="validation-messages">
								<div class="validation-message error" v-if="!$v.fields.mileage.required">Vänligen ange miltal</div>
							</div>
						</div>
					</div>
				</div>

				<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">3. Service och skick *</h2>
					<div class="form-section">
						<div class="radio-group row gap-normal" :class="{ 'has-error': $v.fields.servicePlan.$dirty && $v.fields.servicePlan.$error }">
							<p class="has-body-font-size">Har bilen servats enligt serviceplan på auktoriserad verkstad under den tid du haft bilen?</p>
							<label class="has-caption-font-size d-flex gap-small">
								<input type="radio" :name="blockId + '-service-plan'" value="Ja" v-model="fields.servicePlan" @change="$v.fields.servicePlan.$touch()" />
								Ja
							</label>
							<label class="has-caption-font-size d-flex gap-small">
								<input type="radio" :name="blockId + '-service-plan'" value="Nej" v-model="fields.servicePlan" @change="$v.fields.servicePlan.$touch()" />
								Nej
							</label>
							<div v-if="$v.fields.servicePlan.$error" class="validation-messages">
								<div class="validation-message error">Vänligen svara ja eller nej</div>
							</div>
						</div>

					</div>
					<div
						class="form-group floating-label"
						:class="{
							'has-error': $v.fields.damages.$dirty && $v.fields.damages.$error,
							'has-success': $v.fields.damages.$dirty && !$v.fields.damages.$error && fields.damages && fields.damages.length > 0,
						}"
					>
						<textarea :id="blockId + '-damages'" placeholder=" " v-model="fields.damages" @blur="$v.fields.damages.$touch()" rows="4"></textarea>
						<label :for="blockId + '-damages'" class="floating-label">Skador eller defekter</label>
					</div>

					<div
						class="form-group floating-label"
						:class="{
							'has-error': $v.fields.otherInfo.$dirty && $v.fields.otherInfo.$error,
							'has-success': $v.fields.otherInfo.$dirty && !$v.fields.otherInfo.$error && fields.otherInfo && fields.otherInfo.length > 0,
						}"
					>
						<textarea :id="blockId + '-other-info'" placeholder=" " v-model="fields.otherInfo" @blur="$v.fields.otherInfo.$touch()" rows="4"></textarea>
						<label :for="blockId + '-other-info'" class="floating-label">Övriga upplysningar</label>
					</div>
				</div>

				<div v-if="facilityRecipients.length > 0" class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">4. Välj anläggning</h2>
					<div class="form-section">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.facility.$dirty && $v.fields.facility.$error,
								'has-success': $v.fields.facility.$dirty && !$v.fields.facility.$error && fields.facility && fields.facility.length > 0,
							}"
						>
							<select :id="blockId + '-facility'" v-model="fields.facility" @blur="$v.fields.facility.$touch()" :required="facilityFieldRequired && facilityRecipients.length > 0" class="form-select">
								<option value="">Välj anläggning</option>
								<option v-for="facility in facilityRecipients" :key="facility.id" :value="facility.id">
									{{ facility.name }}
								</option>
							</select>
							<label :for="blockId + '-facility'" class="floating-label">{{ facilityFieldLabel }}</label>
							<div v-if="$v.fields.facility.$error" class="validation-messages">
								<div class="validation-message error">Vänligen välj en anläggning</div>
							</div>
						</div>
					</div>
				</div>

				<div class="form-footer">
					<div class="radio-group" :class="{ 'has-error': $v.fields.privacyPolicy && $v.fields.privacyPolicy.$dirty && $v.fields.privacyPolicy.$invalid && $v.fields.privacyPolicy.$error }">
						<input type="checkbox" :id="blockId + '-checkbox'" v-model="fields.privacyPolicy" @change="$v.fields.privacyPolicy && $v.fields.privacyPolicy.$touch()" />
						<label :for="blockId + '-checkbox'" class="has-caption-font-size">Jag accepterar <a href="/integritetspolicy/" target="_blank" class="has-caption-font-size">integritetspolicyn</a></label>
						<div v-if="$v.fields.privacyPolicy && $v.fields.privacyPolicy.$dirty && $v.fields.privacyPolicy.$invalid && $v.fields.privacyPolicy.$error" class="validation-messages">
							<div class="validation-message error">Du måste acceptera integritetspolicyn</div>
						</div>
					</div>
					<button
						type="button"
						:class="{
							'is-loading': mailSentStatus === 'sending',
							'is-disabled': isFormDisabled,
							'is-filled': !isFormDisabled && !mailSentStatus,
						}"
						class="nitea-button is-primary is-width-auto is-size-default"
						@click="submitForm()"
						:disabled="isFormDisabled"
					>
						Skicka
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import { required, email, minLength, requiredIf } from "vuelidate/lib/validators";

	const mustBeTrue = (value) => value === true;

	const phonePattern = (value) => {
		if (!value) return true;
		const pattern = /^(\+46|0)\s?\d{1,3}[\s\-]?\d{2,3}[\s\-]?\d{2}[\s\-]?\d{2}$/;
		return pattern.test(value);
	};

	export default {
		name: "form-car-valuation-existing-customer",
		props: {
			postId: {
				type: Number,
				default: null,
			},
			isModalOpen: {
				type: Boolean,
				default: false,
			},
			formTitle: {
				type: String,
				default: "",
			},
			formDescription: {
				type: String,
				default: "",
			},
			blockId: {
				type: String,
				default: "form-car-valuation-existing-customer",
			},
			emailRecipients: {
				type: String,
				default: "",
			},
			emailSubject: {
				type: String,
				default: "",
			},
			facilityRecipients: {
				type: Array,
				default: () => [],
			},
			facilityFieldLabel: {
				type: String,
				default: "Välj anläggning",
			},
			facilityFieldRequired: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				mailSentStatus: null,
				fields: {
					firstName: "",
					lastName: "",
					phone: "",
					regnummer: "",
					mileage: "",
					email: "",
					servicePlan: "",
					damages: "",
					otherInfo: "",
					privacyPolicy: false,
					facility: "",
				},
				registrationNumber: {
					isLoading: false,
					error: null,
				},
				car: null,
				localEmailRecipients: this.emailRecipients,
				localEmailSubject: this.emailSubject,
				carInfoTimeout: null,
			};
		},
		computed: {
			isModalMode() {
				return this.isModalOpen;
			},
			selectedFacilityRecipients() {
				if (this.fields.facility && this.facilityRecipients.length > 0) {
					const selectedFacility = this.facilityRecipients.find((f) => f.id === this.fields.facility);
					if (selectedFacility && selectedFacility.recipients) {
						return selectedFacility.recipients.join(", ");
					}
				}
				return this.localEmailRecipients;
			},
			isFormDisabled() {
				return (
					this.mailSentStatus === "sending" ||
					this.$v.fields.$invalid ||
					!this.fields.privacyPolicy ||
					!this.fields.firstName.trim() ||
					!this.fields.lastName.trim() ||
					!this.fields.phone.trim() ||
					!this.fields.regnummer.trim() ||
					!this.fields.mileage.trim() ||
					!this.fields.email.trim() ||
					!this.fields.servicePlan
				);
			},
		},
		validations: {
			fields: {
				firstName: { required },
				lastName: { required },
				phone: { required, phonePattern },
				regnummer: { required, minLength: minLength(6) },
				mileage: { required },
				email: { required, email },
				servicePlan: { required },
				damages: {},
				otherInfo: {},
				privacyPolicy: { mustBeTrue },
				facility: {
					required: requiredIf(function() {
						return this.facilityFieldRequired && this.facilityRecipients.length > 0;
					}),
				},
			},
		},
		watch: {
			emailRecipients(newVal) {
				this.localEmailRecipients = newVal;
			},
			emailSubject(newVal) {
				this.localEmailSubject = newVal;
			},
			"fields.regnummer": {
				handler(newVal) {
					if (newVal) {
						this.fields.regnummer = newVal.toUpperCase();
						clearTimeout(this.carInfoTimeout);
						this.carInfoTimeout = setTimeout(() => {
							if (newVal.length >= 6) {
								this.getCarInfo(this.fields.regnummer);
							}
						}, 500);
					}
				},
				immediate: false,
			},
		},
		mounted() {
			const el = this.$el;
			if (!el || typeof el.hasAttribute !== "function") {
				return;
			}
			if (!this.postId && el.hasAttribute("data-post-id")) {
				const postId = el.getAttribute("data-post-id");
				this.postId = postId ? parseInt(postId) : null;
			}
			if (!this.formTitle && el.hasAttribute("data-form-title")) {
				this.formTitle = el.getAttribute("data-form-title") || "";
			}
			if (!this.formDescription && el.hasAttribute("data-form-description")) {
				this.formDescription = el.getAttribute("data-form-description") || "";
			}
			if (!this.blockId && el.hasAttribute("data-block-id")) {
				this.blockId = el.getAttribute("data-block-id") || "form-car-valuation-existing-customer";
			}
		},
		methods: {
			async getCarInfo(registrationNumber) {
				this.registrationNumber.isLoading = true;
				this.car = null;
				this.registrationNumber.error = null;

				registrationNumber = registrationNumber
					.toString()
					.toUpperCase()
					.replace(" ", "")
					.trim();

				if (registrationNumber.length < 6) {
					this.registrationNumber.isLoading = false;
					return;
				}

				const formData = new FormData();
				formData.append("registration_number", registrationNumber);
				formData.append("action", "nitea_utils_form_get_car_info");
				await fetch(window.nitea_utils_forms_car_valuation_existing_customer.admin_url + "?action=nitea_utils_form_get_car_info", {
					method: "POST",
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.data && data.data.result) {
							this.car = data.data.result;
						} else {
							this.registrationNumber.error = "Kunde inte hämta bilinformation";
						}
						this.registrationNumber.isLoading = false;
					})
					.catch((error) => {
						this.registrationNumber.error = error;
						this.registrationNumber.isLoading = false;
					});
			},
			closeFormMessage() {
				if (this.isModalMode) {
					window.dispatchEvent(
						new CustomEvent("closeFormModal", {
							detail: { formType: "car-valuation-existing-customer" },
						}),
					);
				} else {
					this.mailSentStatus = null;
					this.resetForm();
				}
			},
			closeModal() {
				window.dispatchEvent(
					new CustomEvent("closeFormModal", {
						detail: { formType: "car-valuation-existing-customer" },
					}),
				);
			},
			submitForm() {
				this.$v.$touch();
				if (this.$v.$invalid) {
					return;
				}

				this.mailSentStatus = "sending";

				const formData = new FormData();
				formData.append("action", "nitea_utils_form_post_car_valuation_existing_customer");
				formData.append("post_id", this.postId);
				formData.append("first_name", this.fields.firstName);
				formData.append("last_name", this.fields.lastName);
				formData.append("phone", this.fields.phone);
				formData.append("regnummer", this.fields.regnummer);
				formData.append("mileage", this.fields.mileage);
				formData.append("email", this.fields.email);
				formData.append("service_plan", this.fields.servicePlan);
				formData.append("damages", this.fields.damages);
				formData.append("other_info", this.fields.otherInfo);
				formData.append("privacy_policy", this.fields.privacyPolicy ? "1" : "0");

				if (this.car) {
					if (this.car.brand) formData.append("brand", this.car.brand);
					if (this.car.model) formData.append("model", this.car.model);
					if (this.car.version) formData.append("version", this.car.version);
					if (this.car.model_year) formData.append("year", this.car.model_year);
				}

				if (this.selectedFacilityRecipients) {
					formData.append("email_recipients", this.selectedFacilityRecipients);
				}
				if (this.localEmailSubject) {
					formData.append("email_subject", this.localEmailSubject);
				}
				if (this.fields.facility) {
					formData.append("facility", this.fields.facility);
				}
				if (this.facilityRecipients.length > 0) {
					formData.append("facility_recipients", JSON.stringify(this.facilityRecipients));
				}

				fetch(window.nitea_utils_forms_car_valuation_existing_customer.admin_url + "?action=nitea_utils_form_post_car_valuation_existing_customer", {
					method: "POST",
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.success) {
							this.mailSentStatus = "sent";

							if (typeof window.niteaGTM !== "undefined") {
								let facilityName = null;
								if (this.fields.facility && this.facilityRecipients.length > 0) {
									const selectedFacility = this.facilityRecipients.find((f) => f.id === this.fields.facility);
									if (selectedFacility && selectedFacility.name) {
										facilityName = selectedFacility.name;
									}
								}

								if (facilityName && typeof window.normalizeFacilityName !== "undefined") {
									facilityName = window.normalizeFacilityName(facilityName);
								}

								window.niteaGTM.push({
									interaction_category: "form_car_valuation_existing_customer",
									interaction_type: "submit",
									interaction_status: "success",
									value: 5000,
									customer: {
										type: "private",
									},
									interaction_details: {
										id: "form_car_valuation_existing_customer",
										element_type: "form",
										location: this.isModalMode ? "modal" : "form_selector",
									},
									vehicle: {
										brand: this.car && this.car.brand ? this.car.brand : null,
										model: this.car && this.car.model ? this.car.model : null,
										version: this.car && this.car.version ? this.car.version : null,
										model_year: this.car && this.car.model_year ? this.car.model_year : null,
										fuel_type: this.car && this.car.fuel_type_1 ? this.car.fuel_type_1 : null,
										gearbox: this.car && this.car.gearbox ? this.car.gearbox : null,
										registration_number: this.car && this.car.plate ? this.car.plate : this.fields.regnummer || null,
										mileage: this.fields && this.fields.mileage ? this.fields.mileage : null,
									},
									facility: {
										name: facilityName,
										type: "dealership",
									},
									debug: true,
								});
							}

							this.resetForm();
						} else {
							this.mailSentStatus = "error";
						}
					})
					.catch((error) => {
						console.error("Error:", error);
						this.mailSentStatus = "error";
					});
			},
			resetForm() {
				this.fields = {
					firstName: "",
					lastName: "",
					phone: "",
					regnummer: "",
					mileage: "",
					email: "",
					servicePlan: "",
					damages: "",
					otherInfo: "",
					privacyPolicy: false,
					facility: "",
				};
				this.car = null;
				this.$v.$reset();
			},
		},
	};
</script>
